import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatbotWidget from "./ChatbotWidget";

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <main className="bg-[#FBF9F6] font-manrope">
      <Navbar />
      {children}
      <Footer />
      <ChatbotWidget />
    </main>
  );
}